var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"brand-logo",attrs:{"to":_vm.to,"aria-label":"Iberica Blanca — главная"}},[_c('img',{attrs:{"src":_vm.white ? _vm.whiteLogo : _vm.colorLogo,"alt":"Iberica Blanca — comfortable bathroom"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }